import React, { PureComponent, Suspense, lazy } from 'react'
import Sidebar from './Sidebar'
import { Redirect } from 'react-router'
import SuspenseLoader from './../../components/suspense_loader/SuspenseLoader'
import seasonSettings from './../../components/season_settings/seasonSettings'
import Helmet from 'react-helmet'
import { toTitleCase } from '../../utils/js/shared_helpers'

import './AncillarySport.scss'
import HeaderTitle from '../shared/HeaderTitle'

const LeagueTable = lazy(() => import('./league_table/LeagueTable'))
const Fixtures = lazy(() => import('./fixtures/Fixtures'))
const Odds = lazy(() => import('./odds/Odds'))

class AncillarySport extends PureComponent {
    // key = Url league name/WP slug
    // value arr[0] = Clean league name
    // value arr[1] = Stats league name
    // value arr[2] = Sport
    // value arr[3] = Oddsshark id
    acceptedLeagues = {
        euro: ['UEFA Euro 2024', 'euro', 'soccer', 'euro'],
        natl: ['World Cup 2022', 'natl', 'soccer', 'natl'],
        wwc: ["Women's World Cup", 'wwc', 'soccer', 'wwc'],
        eng_fa_cup: ['FA Cup', 'eng_fa_cup', 'soccer', 'eng_fa_cup'],
        oly_msoc: ['2020 Summer Olympics - Men', 'oly_msoc', 'soccer', 'oly_msoc'],
        oly_wsoc: ['2020 Summer Olympics - Women', 'oly_wsoc', 'soccer', 'oly_wsoc'],
        mls: ['MLS', 'mls', 'soccer', 'mls'],
        bundesliga: ['Bundesliga', 'bund', 'soccer', 'bundesliga'],
        'premier-league': ['Premier League', 'epl', 'soccer', 'epl'],
        'serie-a': ['Serie A', 'seri', 'soccer', 'serie_a'],
        'ligue-1': ['Ligue 1', 'fran', 'soccer', ''],
        'la-liga': ['La Liga', 'liga', 'soccer', 'la_liga'],
        'champions-league': ['Champions League', 'chlg', 'soccer', 'champ_league'],
        chl: ['Memorial Cup', 'chl', 'juniors', ''],
        wjc: ['WJC', 'wjc', 'juniors', ''],
        ohl: ['OHL', 'ohl', 'juniors', ''],
        qmjhl: ['QMJHL', 'qmjhl', 'juniors', ''],
        whl: ['WHL', 'whl', 'juniors', ''],
    }

    isLeague = () => {
        const leagueOrSubPage = this.props.match.params.leagueOrSubPage
        return this.acceptedLeagues.hasOwnProperty(leagueOrSubPage)
    }

    isSportSubPage = () => {
        const leagueOrSubPage = this.props.match.params.leagueOrSubPage
        return leagueOrSubPage === 'scores'
    }

    isOddsPage = () => {
        const dayOrSubPage = this.props.match.params.dayOrSubPage
        return dayOrSubPage === 'odds'
    }

    render() {
        const { sport } = this.props
        const { leagueOrSubPage, dayOrSubPage } = this.props.match.params

        const isLeague = this.isLeague()
        const isSportSubPage = this.isSportSubPage()
        const isOddsPage = this.isOddsPage()

        if (!isLeague && !isSportSubPage && !isOddsPage) {
            return <Redirect to="/" />
        }

        // add chosen season prop from WP to component
        const LeagueComponent = isLeague
            ? seasonSettings(leagueOrSubPage, 'standings')(LeagueTable)
            : null

        return (
            <div className="AncillarySport__cont">
                <div className="inner_cont">
                    <div className="left_col">
                        <Suspense fallback={<SuspenseLoader />}>
                            {isLeague && LeagueComponent && !isOddsPage && (
                                <React.Fragment>
                                    <Helmet
                                        title={`${this.acceptedLeagues[leagueOrSubPage][0]} - Sportsnet.ca`}
                                        link={[
                                            {
                                                rel: 'canonical',
                                                href: `${
                                                    window.location.origin
                                                }/${sport}/scores/${dayOrSubPage || ''}`,
                                            },
                                        ]}
                                    />
                                    <LeagueComponent
                                        league={leagueOrSubPage}
                                        sport={sport}
                                        acceptedLeagues={this.acceptedLeagues}
                                        isStandingsPage={true}
                                    />
                                </React.Fragment>
                            )}
                            {isSportSubPage && leagueOrSubPage === 'scores' && !isOddsPage && (
                                <React.Fragment>
                                    {sport === 'juniors' && (
                                        <HeaderTitle title={'Jr. Hockey Scoreboard'}></HeaderTitle>
                                    )}

                                    <Helmet
                                        title={`${toTitleCase(sport)} Scoreboard - Sportsnet.ca`}
                                        link={[
                                            {
                                                rel: 'canonical',
                                                href: `${
                                                    window.location.origin
                                                }/${sport}/scores/${dayOrSubPage || ''}`,
                                            },
                                        ]}
                                    />
                                    <Fixtures
                                        {...this.props}
                                        acceptedLeagues={this.acceptedLeagues}
                                    />
                                </React.Fragment>
                            )}
                            {isOddsPage && (
                                <React.Fragment>
                                    <Helmet
                                        title={`${this.acceptedLeagues[leagueOrSubPage][0]} Odds - Sportsnet.ca`}
                                        link={[
                                            {
                                                rel: 'canonical',
                                                href: `${window.location.origin}/${sport}/${leagueOrSubPage}/odds`,
                                            },
                                        ]}
                                    />
                                    <Odds {...this.props} acceptedLeagues={this.acceptedLeagues} />
                                </React.Fragment>
                            )}
                        </Suspense>
                    </div>
                    <div className="right_col">
                        <Sidebar
                            sport={sport}
                            league={leagueOrSubPage}
                            acceptedLeagues={this.acceptedLeagues}
                        />
                    </div>
                </div>
            </div>
        )
    }
}

export default AncillarySport
